export const waitMs = (timeoutMs: number) => new Promise(resolve => setTimeout(resolve, timeoutMs))

export const paymentHeaders = () => {
  const x = new Date()
  const currentTimeZoneOffsetInMinutes = x.getTimezoneOffset() || 0

  return {
    'x-fp-timezone': currentTimeZoneOffsetInMinutes.toString(),
    'x-fp-color-depth': window.screen.colorDepth.toString(),
    'x-fp-screen-height': window.screen.width.toString(),
    'x-fp-screen-width': window.screen.height.toString(),
    'x-fp-window-width': document.body.clientWidth.toString(),
    'x-fp-window-height': document.body.clientHeight.toString(),
    'x-fp-java-enabled': (navigator?.javaEnabled() || false).toString(),
    'x-fp-timezone-name': Intl.DateTimeFormat().resolvedOptions().timeZone,
  }
}

export const randomIntFromInterval = (min: number, max: number) => {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min)
}
